import React, { useCallback, useContext } from 'react';

import PropTypes from 'prop-types';
import FilterView from '..';
import { FulfillmentContext } from '../../../../shipping/fulfillments/context';

const FulfillmentsSavedFilterViewContainer = ({ count, displayName = '', filterViewId, openEditViewModal }) => {
  const { activeFilterViewId, switchActiveFilterView } = useContext(FulfillmentContext);
  const isActiveView = activeFilterViewId === filterViewId;

  const launchEditViewModal = useCallback(() => {
    openEditViewModal();
  }, [openEditViewModal]);

  const switchFilterView = useCallback(
    (newFilterViewId) => {
      switchActiveFilterView(newFilterViewId);
    },
    [switchActiveFilterView],
  );

  return (
    <FilterView
      count={count}
      displayName={displayName}
      filterViewId={filterViewId}
      isActive={isActiveView}
      launchEditViewModal={launchEditViewModal}
      onViewClick={isActiveView ? launchEditViewModal : switchFilterView}
    />
  );
};

FulfillmentsSavedFilterViewContainer.propTypes = {
  count: PropTypes.number,
  displayName: PropTypes.string,
  filterViewId: PropTypes.string.isRequired,
  openEditViewModal: PropTypes.func.isRequired,
};

export default FulfillmentsSavedFilterViewContainer;
